export const authCopy = {
  login: {
    title: "Bem-vindo!",
    description: "Informe sua conta para entrar:",
    brandTitle: "Lembre seus clientes pelo WhatsApp",
    brandDescription:
      "Automatize lembretes, avisos e cobranças no momento certo, usando os dados do seu sistema para reduzir tarefas manuais e melhorar o acompanhamento dos seus clientes.",
  },
  loginMfa: {
    title: "Digite o código enviado por e-mail",
    description: "Use o código para confirmar sua identidade e continuar.",
    brandTitle: "Protegendo sua conta e sua operação",
    brandDescription:
      "Uma etapa adicional ajuda a manter sua operação segura sem interromper o fluxo principal.",
  },
  signup: {
    title: "Crie sua conta",
    description: "Informe seus dados para acessar a plataforma.",
    brandTitle: "Comece sua operação com lembretes no WhatsApp",
    brandDescription:
      "Cadastre sua conta para conectar integrações e automatizar comunicações importantes com seus clientes.",
  },
  forgotPassword: {
    title: "Recupere sua senha",
    description:
      "Informe seu e-mail ou usuário para receber o link de recuperação.",
    brandTitle: "Volte para sua operação com segurança",
    brandDescription:
      "A recuperação de senha protege sua conta sem interromper o acesso aos lembretes e cobranças da sua operação.",
  },
  passwordRecovery: {
    title: "Crie uma nova senha",
    description: "Use uma senha forte para voltar a acessar sua conta.",
    actionLabel: "Alterar senha",
    successMessage: "Senha alterada com sucesso.",
    invalidLinkMessage: "Link de recuperação inválido ou expirado.",
    brandTitle: "Volte para sua operação com segurança",
    brandDescription:
      "A redefinição de senha ajuda a manter sua conta segura antes de retomar o acesso à plataforma.",
  },
  createPassword: {
    title: "Crie sua senha",
    description:
      "Você foi convidado para acessar a 123zap. Defina uma senha para concluir seu primeiro acesso.",
    actionLabel: "Criar senha",
    successMessage: "Senha criada com sucesso. Entre para acessar sua conta.",
    invalidLinkMessage:
      "Este convite é inválido ou expirou. Solicite um novo convite ao administrador.",
    brandTitle: "Seu acesso à 123zap está quase pronto",
    brandDescription:
      "Conclua o primeiro acesso com uma senha segura para entrar na conta em que você foi convidado.",
  },
  resetPassword: {
    title: "Redefinir senha",
    description:
      "Informe o código enviado por e-mail e escolha uma nova senha.",
    brandTitle: "Protegendo sua conta e sua operação",
    brandDescription:
      "Uma etapa adicional garante que somente você consiga concluir a redefinição de senha.",
  },
  verifyEmail: {
    title: "Confirme seu e-mail",
    description: "Enviamos um código de 6 caracteres para o seu e-mail.",
    brandTitle: "Finalize seu cadastro com segurança",
    brandDescription:
      "Confirmar seu e-mail mantém sua conta protegida e libera o acesso completo à plataforma.",
  },
  supportAccess: {
    title: "Acesso assistido",
    description: "Preparando acesso assistido...",
    brandTitle: "Acesso assistido seguro",
    brandDescription:
      "Estamos validando o código temporário para iniciar uma sessão de suporte com segurança.",
  },
};
